import { Link } from 'react-router-dom';
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getcarRentCarListing,
  DeleteCarInCarRent,
  UppdateCarInCarRent,
  CarRentAddCar,
  getCarBrand,
  getCarModels,
  getCarModelYear,
  getCarCylinder,
  getCarFuelType,
  getCarSeat,
  getCarDoor,
  getCarColor,
  getCarSafety,
  getCarComfort,
  reorderCarRentCars,
} from './../../../../Redux/Actions/UserAction';
import axios from 'axios';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';
import Swal from 'sweetalert2';

// const API = 'https://api.carsavenue.com/api';
const API = 'https://api.carsavenue.com/api';

const config = () => ({
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
});

export default function RentCarCars() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const home = useSelector((state) => state?.home);

  // Render the right label for the active language: English field for English,
  // Arabic (`*Ar`) field for Arabic, with a fallback to whichever exists.
  const lang = (i18n.language || 'en').toLowerCase().startsWith('ar')
    ? 'ar'
    : 'en';
  const L = (en, ar) => (lang === 'ar' ? ar || en : en || ar);

  // Numeric option lists must be sorted (the API returns them unordered).
  const sortNum = (arr, key, desc) =>
    Array.isArray(arr)
      ? [...arr].sort((a, b) =>
          desc
            ? Number(b[key]) - Number(a[key])
            : Number(a[key]) - Number(b[key])
        )
      : [];

  const CarRentCarList = home?.getCarRentCarList;
  const getlCarRentList = home?.getlCarRentList;

  const CarBrand = home?.garageCarBrandList;
  // Brand-linked car models for the model dropdown (falls back to free text).
  const CarModels = home?.carModels;
  const CarModelYear = home?.CarModelYears;
  const CarCylinder = home?.CarCylinders;
  const CarFuelType = home?.CarFuelTypes;
  const CarSeat = home?.CarSeats;
  const CarDoor = home?.CarDoors;
  const CarColor = home?.CarColors;
  const CarSafety = home?.CarSafety;
  const CarComfort = home?.CarComfort;

  const [update, setUpdate] = useState('');

  useEffect(() => {}, []);

  useEffect(() => {
    dispatch(getcarRentCarListing());

    dispatch(getCarBrand());
    dispatch(getCarModelYear());
    dispatch(getCarCylinder());
    dispatch(getCarFuelType());
    dispatch(getCarSeat());
    dispatch(getCarDoor());
    dispatch(getCarColor());
    dispatch(getCarSafety());
    dispatch(getCarComfort());
  }, [dispatch]);

  console.log('CarRentCarList', CarRentCarList);
  //    console.log('CarBrand',CarBrand);
  //    console.log('CarModelYear',CarModelYear);
  // 	console.log('CarCylinder',CarCylinder);
  // 	console.log('CarFuelType',CarFuelType);
  // 	console.log('CarSeat',CarSeat);
  // 	console.log('CarDoor',CarDoor);
  // 	console.log('CarColor',CarColor);
  // 	console.log('CarSafety',CarSafety);
  // 	console.log('CarComfort',CarComfort);

  /* [CF 2026-08-17 SP1] Starts EMPTY. It used to be seeded with one blank
     package, so an empty Day/Price row was already on screen before the owner
     had asked for one — and pressing "Add packages" then produced a second,
     which is what the client reported as "clicking Add Package creates two
     empty packages instead of one". The fields now appear only after the button
     is pressed. Editing an existing car still fills this from the saved record,
     and submit already refuses a car with no valid package. */
  const [packages, setpackages] = useState([]);

  const [CarRentData, setCarRentData] = useState({
    // carName: '',
    // category: '',
    carBrandId: '',
    carModel: '',
    description: '',
    cyclinderId: '',
    kilometerDriven: '',
    modelYearId: '',
    fuelTypeId: '',
    doorId: '',
    seatId: '',
    interiorColorId: '',
    exteriorColorId: '',
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setCarRentData((user) => ({ ...user, [name]: value }));
  }

  // Load brand-linked car models whenever the selected brand changes.
  useEffect(() => {
    if (CarRentData?.carBrandId) {
      dispatch(getCarModels(CarRentData.carBrandId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CarRentData?.carBrandId]);

  const [File, setFile] = useState([]);

  const [ImageBlob, setImageBlob] = useState([]);

  // On edit, the mediaIds of the car's already-saved images, kept in the same
  // order as the leading entries of ImageBlob. Newly-added (not-yet-uploaded)
  // images come after these. This lets us send the COMPLETE final image set so
  // the backend can replace (not append) the car's images.
  const [editMediaIds, setEditMediaIds] = useState([]);

  // [CF] Primary image: index (within ImageBlob preview order) the owner marked
  // as the cover. The submitted mediaIds array is reordered so this image is
  // FIRST (backend treats index 0 as the cover).
  const [primaryIndex, setPrimaryIndex] = useState(0);

  // [CF] Image multi-select: blob indices the owner ticked for bulk deletion.
  const [selectedForDelete, setSelectedForDelete] = useState([]);

  const toggleSelectForDelete = (index) => {
    setSelectedForDelete((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleRemoveImage = (index) => {
    const existingCount = editMediaIds.length;
    const list = [...ImageBlob];
    list.splice(index, 1);
    setImageBlob(list);

    if (index < existingCount) {
      // Removing an already-saved image -> drop its mediaId from the kept set.
      const ids = [...editMediaIds];
      ids.splice(index, 1);
      setEditMediaIds(ids);
    } else {
      // Removing a newly-added image -> drop the corresponding File.
      const Filelist = [...File];
      Filelist.splice(index - existingCount, 1);
      setFile(Filelist);
    }

    // [CF] Keep the primary selection pointing at the same image after a remove.
    setPrimaryIndex((prev) => {
      if (index === prev) return 0; // removed the primary -> fall back to first
      return index < prev ? prev - 1 : prev;
    });

    // Drop this index from the multi-select set and shift the rest down.
    setSelectedForDelete((prev) =>
      prev.filter((i) => i !== index).map((i) => (i > index ? i - 1 : i))
    );
  };

  // [CF] Bulk-delete every ticked thumbnail in one pass. ImageBlob is ordered
  // [existing..., new...]: existing map to editMediaIds[i], new map to
  // File[i - existingCount]. Filter all parallel arrays by index at once.
  const handleDeleteSelected = () => {
    if (!selectedForDelete.length) return;
    const toRemove = new Set(selectedForDelete);
    const existingCount = editMediaIds.length;

    setImageBlob((prev) => prev.filter((_, i) => !toRemove.has(i)));
    setEditMediaIds((prev) => prev.filter((_, i) => !toRemove.has(i)));
    setFile((prev) => prev.filter((_, fi) => !toRemove.has(fi + existingCount)));
    setPrimaryIndex((prev) => {
      if (toRemove.has(prev)) return 0; // removed the cover -> fall back to first
      const removedBefore = selectedForDelete.filter((i) => i < prev).length;
      return Math.max(0, prev - removedBefore);
    });
    setSelectedForDelete([]);
  };

  const handleUploadImage = (event) => {
    // Bulk upload: process EVERY selected file (was files[0] only), appending
    // each to the File array and generating a preview for each.
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    setFile((prev) => [...prev, ...files]);
    files.forEach((file) => {
      const reader = new FileReader(file);
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setImageBlob((prev) => [...prev, reader.result]);
      };
    });
    event.target.value = '';
  };

  const handleInputAdd = (e, indexValue) => {
    const { name, value } = e.target;
    const list = [...packages];
    list[indexValue][name] = value;
    setpackages(list);
  };

  const [Safety, setSafety] = useState([]);
  const [Comfort, setComforty] = useState([]);

  const handleSafetyChange = (event) => {
    var checkedItem = event.target.value;

    let newArray = [...Safety, checkedItem];

    if (Safety.includes(checkedItem)) {
      newArray = newArray.filter((safe) => safe !== checkedItem);
    }

    setSafety(newArray);
  };

  const handleComfortChange = (event) => {
    var checkedItem = event.target.value;

    let newArray = [...Comfort, checkedItem];

    if (Comfort.includes(checkedItem)) {
      newArray = newArray.filter((comf) => comf !== checkedItem);
    }

    setComforty(newArray);
  };

  const handleRemoveClick = (index) => {
    const list = [...packages];
    list.splice(index, 1);
    setpackages(list);
  };

  const handleAddClick = (e) => {
    setpackages([
      ...packages,
      {
        starting_price: '',
        description: '',
        currency: 'KWD',
        time: '',
        mediaId: '',
      },
    ]);
  };

  // Empty dropdowns post '' which is an invalid UUID for the FK columns and
  // makes the backend reject the whole car. Convert blanks to null so optional
  // fields are simply omitted.
  const clean = (obj) => {
    const out = {};
    Object.keys(obj).forEach((k) => {
      out[k] = obj[k] === '' ? null : obj[k];
    });
    return out;
  };

  // Close the Add/Edit Car modal after a successful submit. The modal is opened
  // via legacy data-toggle, so try Bootstrap 5, then jQuery, then a manual DOM
  // teardown as a last resort — whichever is active.
  const closeAddCarModal = () => {
    const el = document.getElementById('add-new-car');
    if (!el) return;
    try {
      // eslint-disable-next-line global-require
      const { Modal } = require('bootstrap');
      (Modal.getInstance(el) || Modal.getOrCreateInstance(el)).hide();
    } catch (e) {}
    try {
      if (window.$ && window.$(el).modal) window.$(el).modal('hide');
    } catch (e) {}
    // Fallback: if still visible, tear the modal down manually.
    setTimeout(() => {
      if (el.classList.contains('show') || el.style.display === 'block') {
        el.classList.remove('show');
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document
        .querySelectorAll('.modal-backdrop')
        .forEach((b) => b.remove());
    }, 60);
  };

  // [CF] Move the owner-selected primary image to the front of the media array
  // (index 0 = cover on the backend). `mediaIds` is ordered the same as the
  // ImageBlob previews ([existing..., new...]), so primaryIndex lines up.
  const reorderPrimaryFirst = (mediaIds) => {
    if (
      !Array.isArray(mediaIds) ||
      primaryIndex <= 0 ||
      primaryIndex >= mediaIds.length
    )
      return mediaIds;
    const arr = [...mediaIds];
    const [primary] = arr.splice(primaryIndex, 1);
    arr.unshift(primary);
    return arr;
  };

  // Dispatch the add/update with the final, complete image set.
  const submitCar = (finalMediaIds) => {
    // The backend requires a non-empty carName, but the form has no name field.
    // Derive one from the chosen brand + model year.
    const brandObj = (CarBrand || []).find(
      (b) => b.brandId === CarRentData.carBrandId
    );
    const yearObj = (CarModelYear || []).find(
      (y) => y.modelYearId === CarRentData.modelYearId
    );
    const carName =
      [
        brandObj?.name || brandObj?.nameAr,
        CarRentData.carModel,
        yearObj?.modelYear,
      ]
        .filter(Boolean)
        .join(' ') || 'Car';

    const base = {
      ...clean(CarRentData),
      carName,
      packages,
      safetyId: Safety,
      comfortId: Comfort,
      mediaIds: { CAR_IMAGE: finalMediaIds },
    };

    if (update !== '') {
      dispatch(UppdateCarInCarRent({ ...base, carId: update }));
    } else {
      dispatch(CarRentAddCar(base));
    }
    closeAddCarModal();
    submittingRef.current = false;
  };

  // Guard against double-submit (a fast second click would post a duplicate car).
  const submittingRef = useRef(false);

  const UploadImage = (event) => {
    const hasExisting = editMediaIds.length > 0;
    const hasNew = File && File.length > 0;

    if (!hasExisting && !hasNew) {
      Swal.fire({
        title: 'Please upload at least one car image',
        icon: 'warning',
      });
      return;
    }

    if (submittingRef.current) return;
    submittingRef.current = true;

    // Editing without adding new images — keep the existing set (primary first).
    if (!hasNew) {
      submitCar(reorderPrimaryFirst([...editMediaIds]));
      return;
    }

    // Upload the newly-added files, then submit existing-kept + new ids so the
    // backend replaces the car's images with exactly this set.
    const formData = new FormData();
    File.forEach((file) => {
      formData.append('media', file);
    });

    axios
      .post(API + '/media/new', formData, config())
      .then((res) => {
        const uploaded = res.data.response.media;
        const newIds = [...new Set(uploaded.map((data) => data.mediaId))];
        submitCar(reorderPrimaryFirst([...editMediaIds, ...newIds]));
      })
      .catch((err) => {
        submittingRef.current = false;
        Swal.fire({
          title:
            err?.response?.data?.response?.message ||
            err?.response?.data?.message ||
            'Image upload failed. Please try again.',
          icon: 'error',
        });
      });
  };

  const datasubmit = () => {
    // Rental cars only require the essentials: brand, model/type, manufacturing
    // year and at least one rental package. All other car-for-sale details
    // (cylinder, doors, seats, colors, fuel, safety, comfort, km) are optional.
    if (
      !CarRentData.carBrandId ||
      !(CarRentData.carModel || '').trim() ||
      !CarRentData.modelYearId
    ) {
      Swal.fire({
        title: t('Please select brand, model/type and manufacturing year'),
        icon: 'warning',
      });
      return;
    }
    const hasValidPackage = packages.some(
      (p) =>
        String(p?.starting_price || '').trim() !== '' &&
        String(p?.time || '').trim() !== ''
    );
    if (!hasValidPackage) {
      Swal.fire({
        title: t('Please add at least one rental package'),
        icon: 'warning',
      });
      return;
    }
    UploadImage();
  };

  const handlerReset = () => {
    setUpdate('');
    setCarRentData({
      // carName: '',
      // category: '',
      description: '',
      // carModel: '',
      doorId: '',
      seatId: '',
      kilometerDriven: '',
      interiorColorId: '',
      exteriorColorId: '',
      cyclinderId: '',
      carBrandId: '',
      carModel: '',
      modelYearId: '',
      fuelTypeId: '',
    });
    setSafety([]);
    setComforty([]);
    setImageBlob([]);
    setEditMediaIds([]);
    setFile([]);
    setPrimaryIndex(0); // [CF] reset primary selection
    setSelectedForDelete([]); // [CF] clear image multi-select
    setpackages([
      {
        starting_price: '',
        description: '',
        currency: 'KWD',
        time: '',
        mediaId: '',
      },
    ]);
  };

  const onCarEdit = (carDetails) => {
    console.log('carDetails', carDetails);
    setUpdate(carDetails.carId);

    var carMediaData = [
      ...new Set(carDetails.carMedia.map((data) => data?.media?.mediaId)),
    ];

    setCarRentData({
      // carName: carDetails.carName,
      // category: carDetails.category,
      description: carDetails.description,
      carModel: carDetails.carModel,
      doorId: carDetails.doorId,
      seatId: carDetails.seatId,
      kilometerDriven: carDetails.kilometerDriven,
      interiorColorId: carDetails.interiorColorId,
      exteriorColorId: carDetails.exteriorColorId,
      cyclinderId: carDetails.cyclinderId,
      carBrandId: carDetails.carBrandId,
      modelYearId: carDetails.modelYearId,
      fuelTypeId: carDetails.fuelTypeId,
      mediaIds: {
        CAR_IMAGE: carMediaData,
      },
    });
    var safetyIDs = [
      ...new Set(carDetails.safetyId.map((data) => data.safetyId)),
    ];
    setSafety(safetyIDs);

    var comfertIDs = [
      ...new Set(carDetails.comfortId.map((data) => data.comfortId)),
    ];
    setComforty(comfertIDs);

    var ImageUrls = [
      ...new Set(carDetails.carMedia.map((data) => data?.media?.path)),
    ];
    setImageBlob(ImageUrls);
    // Keep the existing image ids (same order as ImageUrls) so the final
    // submit can preserve the ones the owner doesn't remove.
    setEditMediaIds(carMediaData);
    setFile([]);
    setPrimaryIndex(0); // [CF] existing cover is already first
    setSelectedForDelete([]); // [CF] clear image multi-select

    setpackages(carDetails.packages);
  };

  // [CF] Drag-to-reorder the car grid. `orderList` is an optimistic local copy
  // of the listing; we mutate it live during a drag and persist the new order
  // silently on drop. It re-syncs whenever the server listing changes.
  const [orderList, setOrderList] = useState([]);
  const [dragIndex, setDragIndex] = useState(null);

  useEffect(() => {
    setOrderList(Array.isArray(CarRentCarList) ? CarRentCarList : []);
  }, [CarRentCarList]);

  const onDragStart = (index) => () => setDragIndex(index);

  const onDragEnter = (index) => () => {
    if (dragIndex === null || dragIndex === index) return;
    setOrderList((prev) => {
      const next = [...prev];
      const [moved] = next.splice(dragIndex, 1);
      next.splice(index, 0, moved);
      return next;
    });
    setDragIndex(index);
  };

  const onDragEndPersist = () => {
    setDragIndex(null);
    const ids = orderList.map((c) => c?.carId).filter(Boolean);
    if (ids.length) dispatch(reorderCarRentCars(ids));
  };

  const onCarDelete = (carId) => {
    // [CF-15] Confirm before deleting (was deleting instantly).
    Swal.fire({
      title: t('Are you sure?'),
      text: t('This item will be permanently deleted.'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('Yes, delete it'),
      cancelButtonText: t('Cancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(DeleteCarInCarRent({ carId: carId }));
      }
    });
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-rent-car-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-rent-car-cars',
      label: t('Manage Cars'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-rent-car-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-rent-car-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  return (
    <div>
      <CommonBusinessHeader
        dataList={getlCarRentList}
        getNameKey="carRentName"
      />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            {/* <!-- Add new car modal --> */}
            <div
              class="modal fade"
              id="add-new-car"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      {t('Add New Car')}
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <form>
                      {/* <div className="form-group">
                        <label htmlFor="carName">{t('Car Name')}</label>
                        <input
                          class="form-control"
                          id="carName"
                          type="text"
                          name="carName"
                          placeholder={t("Enter car name")}
                          value={CarRentData.carName}
                          onChange={handleChange}
                        />
                      </div> */}
                      {/* <div className="form-group">
                        <label htmlFor="category">{t('Category')}</label>
                        <input
                          class="form-control"
                          id="category"
                          type="text"
                          name="category"
                          placeholder={t("Enter car category")}
                          value={CarRentData.category}
                          onChange={handleChange}
                        />
                      </div> */}
                      <div class="form-group">
                        <label for="anc-car-brand">
                          {t('Select Car Brand')}{' '}
                          <span style={{ color: 'red' }}>*</span>
                        </label>
                        <select
                          class="form-control"
                          id="anc-car-brand"
                          name="carBrandId"
                          value={CarRentData.carBrandId}
                          onChange={handleChange}
                        >
                          <option>{t('- Select Car Brand -')}</option>
                          {CarBrand !== undefined && CarBrand.length
                            ? CarBrand.map((brand, idx) => (
                                <option value={brand.brandId}>
                                  {L(brand.name, brand.nameAr)}
                                </option>
                              ))
                            : null}
                        </select>
                      </div>

                      <div class="form-group">
                        <label for="anc-car-model">
                          {t('Car Model and Series')}{' '}
                          <span style={{ color: 'red' }}>*</span>
                        </label>
                        {Array.isArray(CarModels) && CarModels.length ? (
                          <select
                            class="form-control"
                            id="anc-car-model"
                            name="carModel"
                            value={CarRentData.carModel}
                            onChange={handleChange}
                          >
                            <option value="">
                              {' '}
                              - {t('Select Car Model')} -{' '}
                            </option>
                            {CarModels.map((model, idx) => (
                              <option key={idx} value={model.name}>
                                {L(model.name, model.nameAr)}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            name="carModel"
                            value={CarRentData.carModel}
                            onChange={handleChange}
                            type="text"
                            class="form-control"
                            id="anc-car-model"
                            placeholder={t('Enter Car Model')}
                          />
                        )}
                      </div>

                      {/* <div className="form-group">
                        <label htmlFor="carModel">{t('Model')}</label>
                        <input
                          class="form-control"
                          id="carModel"
                          type="text"
                          name="carModel"
                          placeholder={t("Enter car category")}
                          value={CarRentData.carModel}
                          onChange={handleChange}
                        />
                      </div> */}

                      <div class="btn btn-primary btn-file">
                        <label
                          class="btn text-white upload-button btn-sm"
                          for="files"
                        >
                          <i class="fas fa-folder-open"></i> &nbsp;{' '}
                          {t('Upload your Car Images')} …
                        </label>
                        <input
                          type="file"
                          id="files"
                          accept="image/*"
                          multiple
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>

                      {/* [CF] Bulk image actions: appears once one or more
                          thumbnails are ticked. Delete several images at once. */}
                      {ImageBlob.length > 0 && (
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <small className="text-muted">
                            {selectedForDelete.length > 0
                              ? `${selectedForDelete.length} ${t('selected')}`
                              : t('Tick images to delete multiple at once')}
                          </small>
                          {selectedForDelete.length > 0 && (
                            <button
                              type="button"
                              class="btn btn-sm btn-danger"
                              onClick={handleDeleteSelected}
                            >
                              <i class="far fa-trash-alt"></i>{' '}
                              {t('Delete selected')} ({selectedForDelete.length})
                            </button>
                          )}
                        </div>
                      )}
                      <div class="form-group">
                        <div class="row align-items-center ">
                          {ImageBlob.map((item, indexValue) => {
                            // [CF] Primary image selection: highlight the cover
                            // and let the owner mark any thumbnail as primary.
                            const isPrimary = indexValue === primaryIndex;
                            const isChecked =
                              selectedForDelete.includes(indexValue);
                            return (
                              <div class="col-auto">
                                <div
                                  class=" row-cols-7"
                                  style={{
                                    border: isChecked
                                      ? '2px solid #dc3545'
                                      : isPrimary
                                      ? '2px solid #ffc107'
                                      : '2px solid transparent',
                                    borderRadius: '6px',
                                    padding: '2px',
                                  }}
                                >
                                  <div class="d-flex align-items-center justify-content-between">
                                    <label
                                      class="m-0"
                                      style={{
                                        fontSize: '0.7rem',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={() =>
                                          toggleSelectForDelete(indexValue)
                                        }
                                      />
                                      {t('Select')}
                                    </label>
                                    <button
                                      type="button"
                                      class="close"
                                      // data-dismiss='modal'
                                      // aria-label='Close'
                                      onClick={() =>
                                        handleRemoveImage(indexValue)
                                      }
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <img
                                    style={{
                                      height: '5rem',
                                      width: '8rem',
                                    }}
                                    class="profile-pic img-fluid m-1"
                                    // src='assets/images/camera.jpg'
                                    // src='/Screenshot (4).png'
                                    src={
                                      item !== undefined
                                        ? item
                                        : 'assets/images/camera.jpg'
                                    }
                                    alt=""
                                  />
                                  {isPrimary ? (
                                    <div
                                      class="text-center"
                                      style={{
                                        fontSize: '0.7rem',
                                        color: '#ffc107',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      <i class="fas fa-star"></i> {t('Primary')}
                                    </div>
                                  ) : (
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-outline-warning w-100"
                                      style={{ fontSize: '0.7rem' }}
                                      onClick={() => setPrimaryIndex(indexValue)}
                                    >
                                      {t('Set as primary')}
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {/* [CF] Rental cars only need Brand/Model/Year/Images/
                          Packages — the remaining spec fields are HIDDEN from the
                          add/edit form. They stay in state so existing values are
                          preserved unchanged when editing. */}
                      {/* [CF 2026-08-17 SP3] Client: "previously, when adding a
                          vehicle, there was a Description field, but it is now
                          missing", leaving every new rental car reading "No
                          description available". It was not deleted — it had been
                          swept into the hidden block below when rental was trimmed
                          to Brand/Model/Year/Images/Packages. Only the description
                          is brought back out; the rest of the spec fields stay
                          hidden as the client asked. */}
                      <div class="form-group">
                        <label for="anc-description">
                          {t('Car Description')}{' '}
                          <small>({t('Optional')})</small>
                        </label>
                        <textarea
                          name="description"
                          value={CarRentData.description}
                          onChange={handleChange}
                          class="form-control"
                          id="anc-description"
                          rows="3"
                        ></textarea>
                      </div>

                      {false && (
                        <>
                      <div className="form-group">
                        <label htmlFor="kilometerDriven">
                          {t('Kilometer Driven')} <small>({t('Optional')})</small>
                        </label>
                        <input
                          class="form-control"
                          id="kilometerDriven"
                          type="number"
                          name="kilometerDriven"
                          placeholder={t("Enter kilometers driven")}
                          value={CarRentData.kilometerDriven}
                          onChange={handleChange}
                        />
                      </div>

                      <div class="form-group">
                        <label for="anc-cyclinder">
                          Cyclinder <small>({t('Optional')})</small>
                        </label>
                        <select
                          class="form-control"
                          id="anc-cyclinder"
                          name="cyclinderId"
                          value={CarRentData.cyclinderId}
                          onChange={handleChange}
                        >
                          <option> - Select Cyclinder Type - </option>
                          {sortNum(CarCylinder, 'cyclinder').map(
                            (cylinder, idx) => (
                              <option value={cylinder.cyclinderId}>
                                {cylinder.cyclinder}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                        </>
                      )}

                      <div class="form-group">
                        <label for="anc-model-year">
                          {t('Model Year')} <span style={{ color: 'red' }}>*</span>
                        </label>
                        <select
                          class="form-control"
                          id="anc-model-year"
                          name="modelYearId"
                          value={CarRentData.modelYearId}
                          onChange={handleChange}
                        >
                          <option>- Select Car Model Year-</option>
                          {sortNum(CarModelYear, 'modelYear', true).map(
                            (year, idx) => (
                              <option value={year.modelYearId}>
                                {year.modelYear}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      {false && (
                        <>
                      <div class="form-group">
                        <label for="anc-fuel-type">
                          Fuel Type <small>({t('Optional')})</small>
                        </label>
                        <select
                          class="form-control"
                          id="anc-fuel-type"
                          name="fuelTypeId"
                          value={CarRentData.fuelTypeId}
                          onChange={handleChange}
                        >
                          <option> - Select Fuel Type - </option>
                          {CarFuelType !== undefined && CarFuelType.length
                            ? CarFuelType.map((fuel, idx) => (
                                <option value={fuel.fuelTypeId}>
                                  {L(fuel.fuelType, fuel.fuelTypeAr)}
                                </option>
                              ))
                            : null}
                        </select>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-6">
                            <label for="anc-doors">
                              Doors <small>({t('Optional')})</small>
                            </label>
                            <select
                              class="form-control"
                              id="anc-doors"
                              name="doorId"
                              value={CarRentData.doorId}
                              onChange={handleChange}
                            >
                              <option> - Select Doors Count - </option>
                              {sortNum(CarDoor, 'door').map((door, idx) => (
                                <option value={door.doorId}>{door.door}</option>
                              ))}
                            </select>
                          </div>
                          <div class="col-6">
                            <label for="anc-seats">
                              Seats <small>({t('Optional')})</small>
                            </label>
                            <select
                              class="form-control"
                              id="anc-seats"
                              name="seatId"
                              value={CarRentData.seatId}
                              onChange={handleChange}
                            >
                              <option> - Select Seats Count - </option>
                              {sortNum(CarSeat, 'seat').map((seat, idx) => (
                                <option value={seat.seatId}>{seat.seat}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-6">
                            <label for="anc-interior-color">
                              {t('Interior Color')} <small>({t('Optional')})</small>
                            </label>
                            <select
                              name="interiorColorId"
                              value={CarRentData.interiorColorId}
                              onChange={handleChange}
                              class="form-control"
                              id="anc-interior-color"
                            >
                              <option> - Select Interior Color - </option>
                              {CarColor !== undefined && CarColor.length
                                ? CarColor.map((color, idx) => (
                                    <option value={color.colorId}>
                                      {L(color.color, color.colorAr)}
                                    </option>
                                  ))
                                : null}
                            </select>
                          </div>
                          <div class="col-6">
                            <label for="anc-exterior-color">
                              {t('Exterior Color')} <small>({t('Optional')})</small>
                            </label>
                            <select
                              name="exteriorColorId"
                              value={CarRentData.exteriorColorId}
                              onChange={handleChange}
                              class="form-control"
                              id="anc-exterior-color"
                            >
                              <option> - Select Exterior Color - </option>
                              {CarColor !== undefined && CarColor.length
                                ? CarColor.map((color, idx) => (
                                    <option value={color.colorId}>
                                      {L(color.color, color.colorAr)}
                                    </option>
                                  ))
                                : null}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <h5>{t('Safety & Security')}</h5>
                        <div className="CarForSale_safety">
                          {CarSafety !== undefined && CarSafety.length
                            ? CarSafety.map((safe, idx) => (
                                <div>
                                  <input
                                    type="checkbox"
                                    // name={idx}
                                    id={safe.safetyId}
                                    value={safe.safetyId}
                                    checked={Safety.includes(safe.safetyId)}
                                    onChange={handleSafetyChange}
                                  />
                                  <label htmlFor={safe.safetyId}>
                                    {L(safe.safety, safe.safetyAr)}
                                  </label>
                                </div>
                              ))
                            : null}
                        </div>
                      </div>
                      <div class="form-group">
                        <h5>{t('Comfort and Convienience')}</h5>
                        <div className="CarForSale_safety">
                          {CarComfort !== undefined && CarComfort.length
                            ? CarComfort.map((comf, idx) => (
                                <div>
                                  <input
                                    type="checkbox"
                                    // name={idx}
                                    id={comf.comfortId}
                                    value={comf.comfortId}
                                    checked={Comfort.includes(comf.comfortId)}
                                    onChange={handleComfortChange}
                                  />
                                  <label htmlFor={comf.comfortId}>
                                    {L(comf.comfort, comf.comfortAr)}
                                  </label>
                                </div>
                              ))
                            : null}
                        </div>
                      </div>

                        </>
                      )}

                      <div class="form-group">
                        <h5>{t('Add packages')}</h5>

                        <div id="example-2">
                          <div class="row mb-2">
                            <div class="col-12">
                              <button
                                type="button"
                                id="btnAdd-2"
                                class="btn btn-warning"
                                onClick={handleAddClick}
                              >
                                {t('Add more packages')}
                              </button>
                            </div>
                          </div>
                          {packages.map((x, indexValue) => {
                            return (
                              <div class="row group manage-services-row packageBOX">
                                <div class="col-12 col-sm-12 col-md-5">
                                  <label htmlFor="starting_price">
                                    {t('Starting Price')}
                                  </label>
                                  <input
                                    name="starting_price"
                                    value={x.starting_price}
                                    type="number"
                                    class="form-control"
                                    id="starting_price"
                                    placeholder={t("Starting Price")}
                                    onChange={(e) =>
                                      handleInputAdd(e, indexValue)
                                    }
                                  />
                                </div>

                                {/* <div class="col-12 col-sm-12 col-md-3">
                                  <label htmlFor="currency">
                                    {t('Currency')}
                                  </label>
                                  <select
                                    name="currency"
                                    value={x.currency}
                                    type="number"
                                    class="form-control"
                                    id="currency"
                                    onChange={(e) =>
                                      handleInputAdd(e, indexValue)
                                    }
                                  >
                                    <option value="">- Select -</option>
                                    <option value="USD">USD</option>
                                    <option value="KWD">KWD</option>
                                  </select>
                                </div> */}

                                <div class="col-12 col-sm-12 col-md-4">
                                  <label htmlFor="time">
                                    {t('Time (Day)')}
                                  </label>
                                  <input
                                    name="time"
                                    value={x.time}
                                    type="number"
                                    inputMode="numeric"
                                    class="form-control"
                                    id="time"
                                    placeholder={t("Package Time")}
                                    onChange={(e) =>
                                      handleInputAdd(e, indexValue)
                                    }
                                  />
                                </div>
                                <div class="col-12 col-sm-12 col-md-3">
                                  <div className="rmvButton">
                                    {packages.length >= 1 && (
                                      <button
                                        type="button"
                                        class="btn btn-danger btnRemove"
                                        onClick={() =>
                                          handleRemoveClick(indexValue)
                                        }
                                      >
                                        {t('Remove')}
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="reset"
                      class="btn btn-secondary btn-lg"
                      onClick={handlerReset}
                    >
                      {t('Reset')}
                    </button>
                    <button
                      class="btn btn-warning btn-lg"
                      // href='sp-car-dealers-manage-cars-post.html'
                      onClick={() => datasubmit()}
                    >
                      {update !== '' ? t('Update') : t('Submit')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- Add new car modal --> */}

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <div class="row mb-4 align-items-center justify-content-between">
                <div class="col">
                  <h3 class="mb-0">{t('Manage Cars')}</h3>
                </div>
                <div class="col-auto">
                  <a
                    class="btn btn-outline-secondary"
                    href="javascript:void(0);"
                    role="button"
                    data-toggle="modal"
                    onClick={handlerReset}
                    data-target="#add-new-car"
                  >
                    + {t('Add new Car')}
                  </a>
                </div>
              </div>

              {orderList?.length > 1 && (
                <p className="text-muted small mb-2">
                  <i class="fas fa-arrows-alt"></i>{' '}
                  {t('Drag cars to reorder how they appear')}
                </p>
              )}
              <div class="row">
                {orderList !== undefined && orderList.length
                  ? orderList.map((CAR, idx) => {
                      return (
                        <>
                          <div
                            class="col-6 col-sm-6 col-md-4 mb-5"
                            draggable
                            onDragStart={onDragStart(idx)}
                            onDragEnter={onDragEnter(idx)}
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnd={onDragEndPersist}
                            onDrop={(e) => e.preventDefault()}
                            style={{
                              cursor: 'move',
                              opacity: dragIndex === idx ? 0.5 : 1,
                            }}
                          >
                            <div class="mc-add-car-block">
                              <div
                                class="line-a"
                                style={{
                                  width: '100%',
                                  height: '180px',
                                  overflow: 'hidden',
                                  borderRadius: '8px',
                                  background: '#f4f4f4',
                                }}
                              >
                                <img
                                  src={CAR?.carMedia[0]?.media?.path}
                                  // src='assets/images/user/car-dealers/a.jpg'
                                  class="img-fluid"
                                  alt=""
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                />
                                <div class="line-d">
                                  <div class="row">
                                    <div
                                      class="col-auto"
                                      data-toggle="modal"
                                      data-target="#add-new-car"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => onCarEdit(CAR)}
                                      >
                                        <i class="far fa-edit"></i> {t('Edit')}
                                      </a>
                                    </div>
                                    <div class="col-auto">
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => onCarDelete(CAR?.carId)}
                                      >
                                        <i class="far fa-trash-alt"></i>{' '}
                                        {t('Delete')}
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="line-b">
                                <div class="line-a">
                                  {L(CAR?.brand?.name, CAR?.brand?.nameAr) ||
                                    CAR?.carName}
                                </div>
                                <div class="line-b">
                                  {[CAR?.carModel, CAR?.modelYear?.modelYear]
                                    .filter(Boolean)
                                    .join(' ')}
                                </div>
                                <div class="line-c">
                                  {t('Starting from')}{' '}
                                  <b dir="ltr" style={{ unicodeBidi: 'isolate' }}>
                                    {CAR?.packages[0]?.starting_price}{' '}
                                    {CAR?.packages[0]?.currency?.toUpperCase()} /{' '}
                                    {CAR?.packages[0]?.time} {t('Day')}
                                  </b>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
